import { render, staticRenderFns } from "./MenuItemSelf.vue?vue&type=template&id=604ac678&"
import script from "./MenuItemSelf.vue?vue&type=script&lang=ts&"
export * from "./MenuItemSelf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports